import { render, staticRenderFns } from "./ResourceDuration.vue?vue&type=template&id=7315d9d4&"
import script from "./ResourceDuration.vue?vue&type=script&lang=js&"
export * from "./ResourceDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports